const ENVIRONMENTS = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  LOCAL: 'local'
};

export default ENVIRONMENTS;
